import { useEffect } from 'react'
import { setUpUUIDAction } from 'root-redux/actions/user'
import { TAppDispatch } from 'root-redux/store/store'
import { useDispatch, useSelector } from 'react-redux'
import {
  selectCurrentVariantCohort,
  selectGiaApiKey,
} from 'root-redux/selects/common'

export const useSetUuid = () => {
  const dispatch: TAppDispatch = useDispatch()
  const cohort = useSelector(selectCurrentVariantCohort)
  const giaApiKey = useSelector(selectGiaApiKey)

  useEffect(() => {
    const searchParams = new URLSearchParams(document.location.search)
    const uuidFromUrl = searchParams.get('uuid')

    if (cohort && giaApiKey) {
      dispatch(setUpUUIDAction({ cohort, giaApiKey, uuid: uuidFromUrl }))
    }
  }, [dispatch, cohort, giaApiKey])
}
